module.exports = __webpack_public_path__ + "static/media/navBarIconShoppingList.03c7ee91.svg";